<template>
  <div name="evidenceview" class="inner h-screen">
    <innertopbar @close="closeWindow()">
      <template v-slot:breadcrumb>
        {{ title }}
      </template>
      <template v-slot:listitems>
        <template v-if="!isReadOnly">
          <li
            @click="deletion"
            v-tooltip="{
              content: 'Delete Evidence',
              placement: 'bottom-center',
              offset: 5,
              classes: ['tooltip-info'],
            }"
            title="Delete Evidence"
            class="action-list-item inline-block hover:opacity-100"
          >
            <i class="icon fas fa-trash-alt pt-4" title="Delete Evidence"></i>
          </li>
        </template>
        <li v-if="isReadOnly" class="inline-block">
          <button
          v-if="readonly === false"
            @click="isReadOnly = false"
            type="button"
            class="filter-bar-button hover:opacity-75"
          >
            Edit
          </button>
        </li>
      </template>
    </innertopbar>

    <div class="flex pb-2 block h-90p">
      <i
        class="fas pr-1 text-2xl text-white absolute ml-10 mt-12"
        v-bind:class="
          evidence.media_type === 'video' ? 'fa-video' : 'fa-camera'
        "
      ></i>

      <div class="w-6/12 block bg-white rounded-xl ml-2 mt-4 overflow-y-auto">
        <div class="p-4">
          <evidencevideo
            v-if="evidence.media_type === 'video'"
            reference="'ref_'+index"
            :url="loadFileModal()"
            width="100%"
            height="100%"
            style="min-height: 80vh !important"
          ></evidencevideo>
          <evidenceimage
            v-else
            :url="loadFileModal()"
            reference="'ref_'+index"
            style="height: 280px"
          ></evidenceimage>
        </div>

        <div class="backbar opacity-75 mx-3 mt-3 border-t-2 pt-2 pb-3 w-11/12">
          <div class="grid grid-cols-2 space-x-4 pt-4 ml-2 mr-4">
            <div class="w-full">
              <label class="font-semibold">School Calendar Year</label>

              <div class="mt-2 -ml-1">
                <div v-if="isReadOnly">{{ selectedCalendar.name }}</div>
                <dropdown
                  v-else
                  :options="calendarDropdown"
                  :selected="selectedCalendar"
                  v-on:updateOption="updateCalendarYear"
                  class="w-72 bg-white text-center bg-opacity-75 text-gray-800"
                  style="min-width: 10em"
                >
                  ></dropdown
                >
              </div>
              <p class="text-red-300 text-xs italic pt-1">
                Please fill out this field.
              </p>
            </div>
            <div class="w-full">
              <label class="font-semibold">Class / Group</label>

              <div class="mt-2 -ml-1">
                <div v-if="isReadOnly">{{ presetClassName }}</div>
                <ClassDropdown
                  :classSelected="selectedClass"
                  :presetNameOnly="presetClassName"
                  @classValueChanged="setClassName"
                  class="bg-opacity-75 text-gray-800"
                  v-show="!isReadOnly"
                ></ClassDropdown>
              </div>
              <p class="text-red-300 text-xs italic pt-1">
                Please fill out this field.
              </p>
            </div>
          </div>
          <div class="grid grid-cols-1 space-y-4 py-4 ml-2 mr-4">
            <div class="border-t py-4 mt-4">
              <div class="font-semibold flex justify-between w-full pr-4 pb-4">
                Tags
                <div class="flex" v-if="!isReadOnly">
                  <div
                    class="bg-blue-500 tag-example mr-2 w-10"
                    @click="addTags('sen')"
                  >
                    #sen
                  </div>

                  <div
                    class="bg-orange-500 tag-example"
                    @click="addTags('ofsted')"
                  >
                    #ofsted
                  </div>
                </div>
              </div>

              <div v-if="isReadOnly">{{ tags }}</div>
              <textarea
                v-else
                v-model="tags"
                rows="2"
                class="p-1 mr-2"
              ></textarea>
            </div>

            <div class="border-t mt-4">
              <div class="font-semibold flex justify-between w-full py-4">
                Notes
              </div>
              <div v-if="isReadOnly">{{ evidenceObj.notes }}</div>
              <textarea
                v-else
                v-model="evidenceObj.notes"
                rows="6"
                class="p-1 mr-2"
              ></textarea>
            </div>

            <div v-if="!isReadOnly" class="pt-4">
              <savenotice :title="'Evidence '" ref="notice"></savenotice>
              <button
                @click="publishEvidence()"
                type="button"
                class="publish-button hover:opacity-75 w-full"
              >
                Update evidence details
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="w-6/12 ml-4 mr-2 block mt-4 mr-4">
        <div class="bg-white rounded-xl p-4 ml-2 mt-4 h-full">
          <div class="w-full px-3">
            <h4 class="mb-2 text-base font-semibold">Pupils</h4>
            <div class="h-90p mb-4 pb-4 max-h-screen overflow-y-scroll">
              <div class="flex flex-wrap opacity-100" v-if="pupilsLoaded">
                <table class="table-wrapper w-95p">
                  <thead class="bg-gray-200 text-xs h-10">
                    <th class="text-left pl-2 w-8/12">Name</th>
                    <th class="w-2/12">Selected ({{ pupilsSelectedCount }})</th>
                    <th class="w-2/12">Outcomes</th>
                  </thead>
                  <tbody>
                    <tr v-for="pupil in orderedPupils" :key="pupil.identifier">
                      <td class="pl-3 w-8/12">{{ pupil.name }}</td>
                      <td class="w-2/12 text-center">
                        <button
                          v-if="!isReadOnly"
                          type="button"
                          @click="selectPupil(pupil)"
                          class="rounded-xl my-1 mr-1 w-10 h-8 cursor-pointer focus:outline-none hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue"
                          v-bind:class="[
                            selectedPupilStyle(pupil)
                              ? 'bg-action-blue bg-opacity-75 text-white'
                              : 'bg-gray-200 text-gray-600',
                          ]"
                        >
                          <i
                            class="text-base far"
                            v-bind:class="
                              selectedPupilStyle(pupil)
                                ? 'fa-check-circle'
                                : 'fa-circle'
                            "
                          ></i>
                        </button>
                        <button
                          v-else
                          type="button"
                          class="rounded-xl my-1 mr-1 w-10 h-8 cursor-not-allowed focus:outline-none bg-action-blue bg-opacity-75 text-white"
                        >
                          <i class="text-base far fa-check-circle"></i>
                        </button>
                      </td>
                      <td class="w-2/12 text-right">
                        <div
                          v-if="selectedPupilStyle(pupil)"
                          class="hover:opacity-50 cursor-pointer"
                          @click="showOutcomesForPupil(pupil)"
                        >
                          {{ outcomeCountForPupil(pupil) }}
                          <i class="fas fa-chevron-right px-2"></i>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="text-center w-3/4 mx-auto" v-else>
                <img src="/static/images/empty/empty-plain.png" class="w-10/12 mx-auto" >
                <div class="h-2 bg-gray-200 block">&nbsp;</div>
                <h3 class="text-lg w-full text-center font-bold mt-4 mb-2">Evidence Outcome for Pupils</h3>
                <p>

                No pupils are currently selected. Please edit to add new pupils to the evidence.
                </p>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ModalSlide
      :show="showingOutcomeView"
      :cssWidth="'md:w-6/12'"
      :closeIcon="false"
      @closeModal="closeOutcomeView()"
    >
      <template v-slot:header-icon>
        <i class="fas fa-calendar-alt"></i>
      </template>
      <template v-slot:header-title> {{ title }} </template>
      <template v-slot:body>
        <OutcomeGradeSelection
          v-if="displayOutcomes"
          :course="course"
          :pupil="selectedPupil"
          :readOnly="isReadOnly"
          @outcomeGradeSet="setOutcomeGrade"
          @outcomeGradeDelete="deleteOutcomeGrade"
        ></OutcomeGradeSelection>

        <div v-else class="pl-4">No outcomes available for selected Unit</div>
      </template>
    </ModalSlide>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { calendarYearList } from "@/assets/js/utils";
import { EvidenceService } from "@/services/evidence.service";
import { OutcomeService } from "@/services/outcome.service";
import { pupilMixin } from "@/mixins/pupilMixin.js";
import { fileEvidenceMixin } from "@/mixins/file-EvidenceMixin.js";

const savenotice = () => import("@/components/admin/SaveNotice.vue");

const ModalSlide = () => import("@/components/ModalSlide.vue");

const OutcomeGradeSelection = () =>
  import("@/components/curriculum/OutcomeGradeSelection.vue");
const ClassDropdown = () => import("@/components/pupil/ClassDropdown.vue");
const evidenceimage = () => import("@/components/evidence/EvidenceImage.vue");
const evidencevideo = () => import("@/components/evidence/EvidenceVideo.vue");
const innertopbar = () => import("@/components/InnerTopBar.vue");
const dropdown = () => import("@/components/Dropdown.vue");

export default {
  name: "evidenceview",
  components: {
    evidenceimage,
    evidencevideo,
    innertopbar,
    dropdown,
    ClassDropdown,
    OutcomeGradeSelection,
    ModalSlide,
    savenotice,
  },
  mixins: [pupilMixin, fileEvidenceMixin],
  props: {
    evidence: { type: Object, required: true },
    course: { type: Object, required: false },
    readonly: { type: Boolean, required: true },
    closePath: { type: String, required: true },
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    title() {
       if (this.course != undefined) {
        let selectedYear = this.years.find((year) => this.course.year_id == year.id);
        let yearTitle = selectedYear ? selectedYear.name + " - " : ""
        return  yearTitle + this.course.name + " Passport Evidence"
      } else {
        return "Passport Evidence"
      }
    },
    pupilsLoaded() {
      return this.pupilsSelected.length > 0 || this.isReadOnly === false
    },
    displayOutcomes() {
      return (
        this.showingOutcomeView &&
        (this.pupilsSelected.length > 0 || this.hasSelectedPupil)
      );
    },
    hasSelectedPupil() {
      return this.selectedPupil != undefined || this.selectedPupil != null;
    },
    calendarDropdown() {
      var results = calendarYearList().slice(0, 3);
      this.selectedCalendar = results[0];
      return results;
    },
    hasNotes() {
      return this.evidence.notes != undefined && this.evidence.notes.length > 0;
    },
    orderedPupils() {
      var vm = this;
      var classChosen = vm.selectedClass;

      if (this.isReadOnly) {
        return _.orderBy(this.pupilsSelected, ["yeargroup", "class", "name"]);
      } else {
        if (classChosen == undefined) {
          return _.orderBy(this.pupilArray, ["yeargroup", "class", "name"]);
        } else {
          var filtered = vm.pupilArray.filter(function (pupil) {
            let filtered = true;

            if (filtered) {
              if (classChosen.id > 0) {
                filtered = pupil.inclass === classChosen.name;
              }
            }
            return filtered;
          });

          return _.orderBy(filtered, ["yeargroup", "class", "name"]);
        }
      }
    },
  },
  created() {
    if (this.evidence == undefined) {
      this.closeWindow();
      return;
    } else {
      this.evidenceObj = this.evidence;
      this.fetchOutcomeGrades();
      this.fetchPupils();
    }
  },
  mounted() {
    if (
      this.evidence.inclass != undefined &&
      this.evidence.inclass.length > 0
    ) {
      this.presetClassName = this.evidence.inclass;
    }

    // calendar
    let calendarYear = calendarYearList().find((y) => y.current === true);
    let evidenceCalendar = calendarYearList().find(
      (y) => y.value === this.evidence.calendar_schoolyear
    );
    if (evidenceCalendar) {
      this.selectedCalendar = evidenceCalendar;
    } else {
      this.selectedCalendar = calendarYear;
    }

    // tags
    if (this.evidence.tags != undefined) {
      let tagList = this.evidence.tags.map(function (t) {
        return " #" + t.tag_name;
      });

      this.tags = tagList.join(", ");
    }
  },
  data() {
    return {
      errored: false,
      loading: false,
      inSaving: false,
      selectedClass: {},
      selectedCalendar: {},
      presetClassName: undefined,
      pupilsSelected: [],
      evidenceObj: {},
      tags: "",
      isReadOnly: true,
      showingOutcomeView: false,
      outcomeMarks: [],
      selectedPupil: undefined,
      hasMultipleSelection: false,
    };
  },
  methods: {
    loadFileModal() {
      let folder = this.wordNumericValue(this.currentUser.schoolID);
      return folder + "/" + this.evidence.media_url;
    },
    fetchPupils() {
      this.loading = true;
      EvidenceService.getPupils(this.evidence)
        .then((response) => (this.pupilsSelected = response.data.data))
        .catch((err) => {
          this.failure(err);
        })
        .finally(() => (this.loading = false));
    },
    fetchOutcomeGrades() {
      // fetch grades
      OutcomeService.getCourseGrades(this.course.id)
        .then((response) => (this.outcomeMarks = response.data.data))
        .catch((err) => {
          console.log("Grades " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    outcomeCountForPupil(pupil) {
      let results = this.outcomeMarks
        .filter((o) => o.register_identifier === pupil.identifier)
        .map((m) => m.outcome_identifier);

      const unique = [...new Set(results.map((item) => item))];
      return unique.length;
    },
    publishEvidence() {
      this.evidence.tags = this.tags;
      this.evidence.inclass = this.selectedClass.name;
      this.evidence.calendar_schoolyear = this.selectedCalendar.value
      this.evidence.notes = this.evidenceObj.notes

      EvidenceService.update(this.evidence)
        .then((response) => {
          console.log(response.data);
          this.$refs.notice.saved();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deletion() {
      this.$swal({
        title: "Are you sure you want to delete?",
        text: "You will not be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete!",
      }).then((result) => {
        if (result.value === true) {
          this.processDelete();
        }
      });
    },
    processDelete() {
      EvidenceService.delete(this.evidence)
        .then((response) => this.closeWindow())
        .catch((err) => {
          this.failure(err);
        })
        .finally(() => (this.inSaving = false));
    },
    failure(error) {
      this.errored = true;
      console.log(" update error " + error);
    },
    setClassName(item) {
      if (this.selectedClass == null || this.selectedClass.id != item.id) {
        this.selectedClass = item;
      }
    },
    updateCalendarYear(cal) {
      this.selectedCalendar = cal;
    },
    addTags(value) {
      let seperator = this.tags.length > 0 ? " #" : "#";
      this.tags = this.tags + seperator + value;
    },
    closeWindow() {
      this.$router.push(this.closePath);
      window.scrollTo(0, 0);
    },
    selectedPupilStyle(pupil) {
      return this.isPupilSelected(pupil);
    },
    selectPupil(pupil) {
      const vm = this;
      if (this.isPupilSelected(pupil)) {
        EvidenceService.deletePupil(vm.evidence, pupil)
          .then((response) => {
            vm.pupilsSelected.splice(
              vm.pupilsSelected.findIndex(
                (item) => item.identifier === pupil.identifier
              ),
              1
            );
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        let payload = {
          evidence_identifier: vm.evidence.identifier,
          register_identifier: pupil.identifier,
        };
        EvidenceService.addPupil(payload)
          .then((response) => {
            vm.pupilsSelected.push(pupil);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    showOutcomesForPupil(pupil) {
      this.selectedPupil = pupil;
      this.showingOutcomeView = true;
    },
    setOutcomeGrade(object, grade) {
      let vm = this;
      if (this.hasMultipleSelection) {
        vm.pupils.forEach(function (pp, index) {
          vm.processCreateGrade(pp, grade, object);
        });
      } else {
        this.processCreateGrade(this.selectedPupil, grade, object);
      }
    },
    processCreateGrade(pupil, grade, object) {
      let vm = this;
      let calendarYear = calendarYearList().find((y) => y.current === true);

      let payload = {
        course_id: vm.course.id,
        register_identifier: pupil.identifier,
        calendar_schoolyear: calendarYear.value,
        grade: grade.score,
        outcome_identifier: object.identifier,
        evidence_identifier: this.evidence.identifier,
      };

      OutcomeService.addGrade(payload)
        .then((response) => {
          payload.identifier = response.data.identifier;
          vm.outcomeMarks.push(payload);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteOutcomeGrade(object) {
      let vm = this;
      OutcomeService.deleteGrade(object)
        .then((response) => {
          vm.outcomeMarks = vm.outcomeMarks.filter(
            (o) => o.identifier !== object.identifier
          );
        })
        .catch((err) => {
          console.log("GRADE DELETE error " + err);
        });
    },
    closeOutcomeView() {
      this.showingOutcomeView = false;
      this.selectedPupil = undefined;
      //this.hasMultipleSelection = false
      //this.clearSelections();
    },
  },
};
</script>

<style scoped>
</style>
